export const ApiBaseUrl = 'https://host4vip.com/api';
export const GoogleMapUrl = 'https://www.google.com/maps/embed/v1/place?q=';
export const GoogleMapKey = 'AIzaSyA2eArARFJFQLBMcJ85fTANFelue5f9eqU';
export const GoogleClientId = '895512561633-uu0lesofeik52bsg0g4mhbgt0j68j8dt.apps.googleusercontent.com';
export const FacebookAppId = '204370623761088';
export const StripeKey = 'pk_test_51J80vSHQ2jAA3QszJzT4vT2PrpGr4BNAgOaJd1gAUdyLCkcVP325SgQKCP6GB9RCrxLjgio3Zm64SNQSDIegq8Kb00zc6p4et6';
export const SilverbackPhone = '+91-9888766654';
export const SilverbackEmail = 'support@host4vip.com';
export const SilverbackInfoEmail = 'info@host4vip.com';
export const AndroidAppUrl = 'https%3A%2F%2Fplay.google.com%2F';
export const IosAppUrl = 'https%3A%2F%2Fapps.apple.com%2Fus%2F';
export const PwaAppUrl = 'https%3A%2F%2Fhost4vip.com%2Fhome%2F';
export const SilverbackName = 'Aakash';
export const OwlCarouselOptions = {
    loop:false,
    dots:false,
    margin:10,
    nav:true,
    autoplay:false,
    rewind:false,
    slideBy:2,
    navText: [
        '<i class="fa fa-angle-left" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right" aria-hidden="true"></i>'
    ],
    responsive:{
        0:{
            items:1.15,
            slideBy: 1,
            loop:true
        },
        480:{
            items: 1,
            slideBy: 1
        },
        600:{
            items: 2,
            slideBy: 1
        },
        1024:{
            items:3
        }
    }
};
export const appendAddToAnyScript = () => {
    var a = document.createElement('script');
    a.async = true;
    a.src = 'https://static.addtoany.com/menu/page.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(a, s);
}
export const removeAddToAnyScript = () => {
    let allsuspects=document.getElementsByTagName("script");
    for (let i=allsuspects.length; i>=0; i--){
        if (allsuspects[i] && allsuspects[i].getAttribute("src")!==null
            && allsuspects[i].getAttribute("src").indexOf('https://static.addtoany.com/menu/page.js') !== -1 ){
            allsuspects[i].parentNode.removeChild(allsuspects[i])
        }
    }
}

export const SnackbarOptions = {
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
}